import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { TranslateService } from '@ngx-translate/core';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { Employee } from 'src/app/Interfaces/hr/employee';

@Component({
  selector: 'app-employee-information',
  templateUrl: './employee-information.component.html',
  styleUrls: ['./employee-information.component.scss']
})
export class EmployeeInformationComponent implements OnInit {
  customDataSource: Employee[] = [];
  workStatusMenu: any = [];
  button = {};
  currentLang: any;
  branchesdropdown:any;
  jobTitleDropDown:any;
  bankDropDown:any;
  departmentDropDown:any;
  managementDropDown:any;
  currentuser:any
  UserDropDown:{}[]=[]
  loading:boolean
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(
    private _EmployeeService: EmployeeService,
    private gt: genericCustomStoreService,
    public router: Router,
    public translate: TranslateService,
    private notifyService: NotifyService
  ) {}

  ngOnInit(): void {
    // Fetch employee information and assign it to the data grid's dataSource
    this._EmployeeService.getallemployeeinformation().subscribe(
      (data) => {
        this.customDataSource = data; // Assign API data to customDataSource
      },
      (error) => {
        console.error("Error fetching employee information:", error);
      }
    );

    this.currentLang = localStorage.getItem('Language') || 'en'; // Assuming you store the language key
    this.getbranchdropdown();
    this.getAllJobTitledDropDown() ;
    this.getAllbankDropDown();
    this.getAlldepartmentDropDown();
    this.getAllmanagementDropDown();
    this.getUserDroDown();
  }
  getAllJobTitledDropDown() {
    this.gt.getdropdowndata("JobTitle").subscribe((res: []) => {
      this.jobTitleDropDown = res
    })
  }

  getAllbankDropDown() {
    this.gt.getdropdowndata("Bank").subscribe((res: []) => {
      this.bankDropDown = res
    })
  }
  getAlldepartmentDropDown() {
    this.gt.getdropdowndata("Department").subscribe((res: []) => {
      this.departmentDropDown = res
    })
  }
  getUserDroDown() {
    this.loading = true;
    this.gt.getdropdowndata("User").subscribe(
      (res: {}[]) => {
        this.UserDropDown = res;
        console.log(this.UserDropDown);  // Check if the data is being assigned
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching user data:', error);
        this.loading = false;
      }
    );
  }
  
  getAllmanagementDropDown() {
    this.gt.getdropdowndata("Management").subscribe((res: []) => {
      this.managementDropDown = res
    })
  }

getbranchdropdown(){
  this.gt.getdropdowndata('Branch').subscribe((res: []) => {
    this.branchesdropdown = res
  })
}
}
